var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-btn"},[_c('v-btn',{attrs:{"icon":"","disabled":_vm.disabled},on:{"click":_vm.test}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("cloud_download")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }